module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_MaizQuesoHabanero.ec54b8b6.pdf";